import request from '@remote/api/adapter'
import { IErrorRes } from '@remote/type'
const getClientUuid = () => '1111'

interface ResultInterface<T> {
  code: number
  data: T
  ret?: number
  msg?: string
  [key: string]: any
}

export interface IOSSRole { // oss上传凭证，upload时为空
  endPoint: string
  bucketName: string
  objectPath: string, // 资源一级目录
  accessKeyId: string
  accessKeySecret: string
  securityToken: string
  expiration: string
  callbackUrl: string // 上传回调url，upload时为空
}

/** oss上传获取oss实例配置 */
interface IGetOSSClientConfigParmas {
  task: 'upload' | 'download'
  deviceId: string
  path: string
  size?: number
  gcid?: string
  chunkSize?: number
}

export function getOSSClientConfig (params: IGetOSSClientConfigParmas): Promise<[IErrorRes, ResultInterface<{
  taskId: string
  resourceId: string
  hit: boolean
  ossRole: IOSSRole
}>]> {
  const url = '/xhub/add_task'
  const data = {
    platform: 'pc',
    xos_ver: '',
    clientUuid: getClientUuid(),
    ...params,
  }
  return request(url, data, { method: 'POST', apiEnv: 'heziProduction' })
}

interface IGetOSSCallbackParams {
  bucket: string
  filename: string
  size: string
  etag: string
}

export function getOSSCallback (params: IGetOSSCallbackParams) {
  const url = '/xhub/callback'
  const data = {
    platform: 'pc',
    xos_ver: '',
    clientUuid: getClientUuid(),
    ...params,
  }
  return request(url, data, { method: 'POST', apiEnv: 'heziProduction' })
}

// status	说明	备注
// - 1	失效	任务失效，客户端更新
// - 2	已过期	超时未完成，服务端更新
// 1	完成	客户端 / 设备端完成任务后上报
// 2	待处理	默认状态，创建任务时，服务端记录
// 3	处理中	客户端 / 设备端开始 / 恢复本端任务时上报
// 5    客户端预处理
interface IUpdateOSSTaskParams {
  taskId: string
  status: number
  gcid?: string
}

export function updateOSSTaskStatus (params: IUpdateOSSTaskParams): Promise<[IErrorRes, ResultInterface<{}>]> {
  const url = '/xhub/update_task'
  const data = {
    platform: 'pc',
    xos_ver: '',
    clientUuid: getClientUuid(),
    ...params,
  }
  console.log('--[updateOSSTaskStatus]--', data)
  return request(url, data, { method: 'POST', apiEnv: 'heziProduction' })
}

interface IUpdateOSSTaskParams {
  taskId: string
  status: number
  gcid?: string
}


// device_id	string	否	设备id，v1必需
// userid	string	否	用户id，v2必需
// biz	string	是	作业
// status	int	否	状态：空 进行中；1 完成
// page	int	否	页码，默认1
// page_nums	int	否	每页数量，默认10
interface IGetJobInfoParams {
  device_id: string
  userid?: string
  biz: 'deliver_upload'
  job_ids?: string[]
  // status: 0 | 1
}

export type TJobInfoItem = {
  biz: string
  biz_group: string
  job_id: string
  name: string
  device_id: string
  app_id: number
  expire: number
  progress: number
  expire_at: number
  status: 2
  ext_data: string
}

export function getJobInfo (params: IGetJobInfoParams): Promise<[IErrorRes, ResultInterface<{ total: number; list: TJobInfoItem[] }>]> {
  const url = '/api/v2/job/get_info'
  const data = {
    platform: 'pc',
    xos_ver: '',
    clientUuid: getClientUuid(),
    page: 1,
    page_nums: 20,
    ...params,
  }
  return request(url, data, { method: 'POST', apiEnv: 'heziProduction' })
}

export type TGetOSSCompletedChunksResp = ResultInterface<{
  complete: boolean
  list: number[]
  total: number
  ossRole: IOSSRole
  taskId: string
  resourceId: string
}>

export function getOSSCompletedChunks (resourceId: string): Promise<[IErrorRes, TGetOSSCompletedChunksResp]> {
  const url = '/xhub/get_chunk'
  const data = {
    platform: 'pc',
    xos_ver: '',
    clientUuid: getClientUuid(),
    resourceId,
  }
  return request(url, data, { method: 'POST', apiEnv: 'heziProduction' })
}

export interface ITask {
  task: 'upload' | 'download'
  taskId: string
  platform: 'an' | 'ios' | 'pc'
  clientUuid: string
  resourceId: string
  path: string
  size: number
  chunkSize: number
  client_status: number // 客户端状态：1 完成；2待处理；3处理中；-1失效；
  device_status: number// 设备状态：1 完成；2待处理；3处理中；-1失效；
  status: number// 任务状态：1 完成；2待处理；3处理中；4 暂停；-1失效；-2已过期
  extData: string
}

export function getTask (deviceId: string): Promise<[IErrorRes, ResultInterface<{
  list: ITask[]
}>]> {
  const url = 'xhub/get_task'
  const data = {
    platform: 'pc',
    xos_ver: '',
    clientUuid: getClientUuid(),
    deviceId,
  }
  return request(url, data, { method: 'POST', apiEnv: 'heziProduction' })
}

export function getDownloadUrl (resourceId: string): Promise<[IErrorRes, ResultInterface<{
  list: ITask[]
}>]> {
  const url = 'deliver/download'
  const data = {
    platform: 'pc',
    xos_ver: '',
    clientUuid: getClientUuid(),
    resourceId,
  }
  return request(url, { params: data }, { apiEnv: 'heziProduction' })
}